export enum GenericOperator {
  Equals = 'equals',
  NotEquals = 'not_equals',
  In = 'in',
  NotIn = 'not_in',
}
